import { FieldType } from '@framework/core/Enums';
import { IEntityModelField, IEntityModel } from '@framework/interfaces/IEntityModel';
export interface IJobCardFields {
		id?: any;
		workOrderId?: any;
		jobCardNo?: any;
		dateIssued?: any;
		operationId?: any;
		priorityId?: any;
		dateScopedOut?: any;
		dateScopedIn?: any;
		dateScopeEstimator?: any;
		dateQuoteSubmitted?: any;
		plannedAmountExVat?: any;
		dateOriginalPOIssued?: any;
		originalPurchaseOrderNo?: any;
		plannedStartDate?: any;
		actualStartDate?: any;
		dateHandedOver?: any;
		handoverCertNo?: any;
		datestamp?: any;
		changedBy?: any;
		status?: any;
		contactPersonId?: any;
		contactNo?: any;
		workflowStatusId?: any;
		plannedCompletionDate?: any;
		actualCompletionDate?: any;
		dateCancelled?: any;
		dateDocsRcvd?: any;
		dateDocsToCommercial?: any;
		remarks?: any;
		amount?: any;
		prefix?: any;
		wipStatus?: any;
		shutDownCard?: any;
		buildAmount?: any;
		breakAmount?: any;
		hireAmount?: any;
		miscellaneousAmount?: any;
		tempJobCardNo?: any;
		quoteNumber?: any;
}

export class JobCardFields extends Array<IEntityModelField> {
	public id: IEntityModelField = { name: "id", displayName: "Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true, keyField: true };
	public workOrderId: IEntityModelField = { name: "workOrderId", displayName: "Work Order Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public jobCardNo: IEntityModelField = { name: "jobCardNo", displayName: "Job Card No", fieldType: FieldType.Int, pattern: "NameGeneric" };
	public dateIssued: IEntityModelField = { name: "dateIssued", displayName: "Date Issued", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public operationId: IEntityModelField = { name: "operationId", displayName: "Operation Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public priorityId: IEntityModelField = { name: "priorityId", displayName: "Priority Id", fieldType: FieldType.Int, pattern: "NameGeneric", required: true };
	public dateScopedOut: IEntityModelField = { name: "dateScopedOut", displayName: "Date Scoped Out", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public dateScopedIn: IEntityModelField = { name: "dateScopedIn", displayName: "Date Scoped In", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public dateScopeEstimator: IEntityModelField = { name: "dateScopeEstimator", displayName: "Date Scope Estimator", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public dateQuoteSubmitted: IEntityModelField = { name: "dateQuoteSubmitted", displayName: "Date Quote Submitted", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public plannedAmountExVat: IEntityModelField = { name: "plannedAmountExVat", displayName: "Planned Amount Ex Vat", fieldType: FieldType.Float, pattern: "NameGeneric" };
	public dateOriginalPOIssued: IEntityModelField = { name: "dateOriginalPOIssued", displayName: "Date Original POIssued", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public originalPurchaseOrderNo: IEntityModelField = { name: "originalPurchaseOrderNo", displayName: "Original Purchase Order No", fieldType: FieldType.String, pattern: "NameGeneric" };
	public plannedStartDate: IEntityModelField = { name: "plannedStartDate", displayName: "Planned Start Date", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public actualStartDate: IEntityModelField = { name: "actualStartDate", displayName: "Actual Start Date", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public dateHandedOver: IEntityModelField = { name: "dateHandedOver", displayName: "Date Handed Over", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public handoverCertNo: IEntityModelField = { name: "handoverCertNo", displayName: "Handover Cert No", fieldType: FieldType.String, pattern: "NameGeneric" };
	public datestamp: IEntityModelField = { name: "datestamp", displayName: "Datestamp", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public changedBy: IEntityModelField = { name: "changedBy", displayName: "Changed By", fieldType: FieldType.String, pattern: "NameGeneric" };
	public status: IEntityModelField = { name: "status", displayName: "Status", fieldType: FieldType.Int, pattern: "NameGeneric" };
	public contactPersonId: IEntityModelField = { name: "contactPersonId", displayName: "Contact Person Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public contactNo: IEntityModelField = { name: "contactNo", displayName: "Contact No", fieldType: FieldType.String, pattern: "NameGeneric" };
	public workflowStatusId: IEntityModelField = { name: "workflowStatusId", displayName: "Workflow Status Id", fieldType: FieldType.Int, pattern: "NameGeneric" };
	public plannedCompletionDate: IEntityModelField = { name: "plannedCompletionDate", displayName: "Planned Completion Date", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public actualCompletionDate: IEntityModelField = { name: "actualCompletionDate", displayName: "Actual Completion Date", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public dateCancelled: IEntityModelField = { name: "dateCancelled", displayName: "Date Cancelled", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public dateDocsRcvd: IEntityModelField = { name: "dateDocsRcvd", displayName: "Date Docs Rcvd", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public dateDocsToCommercial: IEntityModelField = { name: "dateDocsToCommercial", displayName: "Date Docs To Commercial", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public remarks: IEntityModelField = { name: "remarks", displayName: "Remarks", fieldType: FieldType.String, pattern: "NameGeneric" };
	public amount: IEntityModelField = { name: "amount", displayName: "Amount", fieldType: FieldType.Float, pattern: "NameGeneric" };
	public prefix: IEntityModelField = { name: "prefix", displayName: "Prefix", fieldType: FieldType.String, pattern: "NameGeneric" };
	public wipStatus: IEntityModelField = { name: "wipStatus", displayName: "Wip Status", fieldType: FieldType.Int, pattern: "NameGeneric" };
	public shutDownCard: IEntityModelField = { name: "shutDownCard", displayName: "Shut Down Card", fieldType: FieldType.Byte, pattern: "NameGeneric" };
	public buildAmount: IEntityModelField = { name: "buildAmount", displayName: "Build Amount", fieldType: FieldType.Float, pattern: "NameGeneric" };
	public breakAmount: IEntityModelField = { name: "breakAmount", displayName: "Break Amount", fieldType: FieldType.Float, pattern: "NameGeneric" };
	public hireAmount: IEntityModelField = { name: "hireAmount", displayName: "Hire Amount", fieldType: FieldType.Float, pattern: "NameGeneric" };
	public miscellaneousAmount: IEntityModelField = { name: "miscellaneousAmount", displayName: "Miscellaneous Amount", fieldType: FieldType.Float, pattern: "NameGeneric" };
	public tempJobCardNo: IEntityModelField = { name: "tempJobCardNo", displayName: "Temp Job Card No", fieldType: FieldType.String, pattern: "NameGeneric" };
	public quoteNumber: IEntityModelField = { name: "quoteNumber", displayName: "Quote Number", fieldType: FieldType.String, pattern: "NameGeneric" };

	constructor() {
		super();
		this.push(this.id);
		this.push(this.workOrderId);
		this.push(this.jobCardNo);
		this.push(this.dateIssued);
		this.push(this.operationId);
		this.push(this.priorityId);
		this.push(this.dateScopedOut);
		this.push(this.dateScopedIn);
		this.push(this.dateScopeEstimator);
		this.push(this.dateQuoteSubmitted);
		this.push(this.plannedAmountExVat);
		this.push(this.dateOriginalPOIssued);
		this.push(this.originalPurchaseOrderNo);
		this.push(this.plannedStartDate);
		this.push(this.actualStartDate);
		this.push(this.dateHandedOver);
		this.push(this.handoverCertNo);
		this.push(this.datestamp);
		this.push(this.changedBy);
		this.push(this.status);
		this.push(this.contactPersonId);
		this.push(this.contactNo);
		this.push(this.workflowStatusId);
		this.push(this.plannedCompletionDate);
		this.push(this.actualCompletionDate);
		this.push(this.dateCancelled);
		this.push(this.dateDocsRcvd);
		this.push(this.dateDocsToCommercial);
		this.push(this.remarks);
		this.push(this.amount);
		this.push(this.prefix);
		this.push(this.wipStatus);
		this.push(this.shutDownCard);
		this.push(this.buildAmount);
		this.push(this.breakAmount);
		this.push(this.hireAmount);
		this.push(this.miscellaneousAmount);
		this.push(this.tempJobCardNo);
		this.push(this.quoteNumber);
	}
}

export class JobCardDTO implements IEntityModel {
	protected jobCardName: string = "JobCardModel";
	protected jobCardKeyField: string = "id";
	protected jobCardDisplayName: string = "Job Card|Job Cards";
	protected jobCardFields = new JobCardFields();
	public get name(): string { return this.jobCardName };
	public get keyField(): string { return this.jobCardKeyField };
	public get displayName(): string { return this.jobCardDisplayName };
	public get fields(): JobCardFields { return this.jobCardFields };

	constructor() {};
}
